export { default } from './Donation';



// WEBPACK FOOTER //
// ./src/components/Donation/index.js